export default "__VITE_ASSET__CpWUlAr7__"